
import { Component } from 'vue-property-decorator';
import ElementBase from './ElementBase';
import { ClassMap } from '../configuration/ElementConfiguration';
import { AccountApiClient, AccountSelect } from '../../backend/backendapi';
import { initClient } from "../../../api";

@Component({
  name: 'AccountSelector',
  components: {},
})
export default class AccountSelector extends ElementBase {
  private readonly accountApi = initClient(AccountApiClient);
  accountSelect: AccountSelect | null = null;

  constructor() {
    super();
    this.lastDataUpdate = new Date(0);
    this.timeoutSeconds = 120;
  }

  async mounted(): Promise<void> {
    await super.mounted();
    await this.reload();
  }

  async reload(): Promise<void> {
    this.accountSelect = await this.accountApi.getAccountSelect(undefined);
    this.lastDataUpdate = new Date();
  }

  protected defaultClass(): ClassMap {
    return Object.assign({}, super.defaultClass(), { 'form-control': true });
  }

  async onSelected(): Promise<void> {
    if (!this.accountSelect) {
      return;
    }
    await this.accountApi.saveAccountSelect(this.accountSelect!);
    window.location.reload();
  }
}
